// extracted by mini-css-extract-plugin
module.exports = {"inner":"Preview_inner__2rq5n","title":"Preview_title__H27RM","close":"Preview_close__2iHv4","card":"Preview_card__1-S1H"};